import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { CalcScreen, FormulaBlock, formulaTextStyles } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type Formula = { title: string; formula: string; description: string };

const FORMULAS: Formula[] = [
  {
    title: 'Air Changes Required',
    formula: 'CFM = (Room Volume × ACH) / 60',
    description: 'Required airflow for a target air changes per hour.',
  },
  {
    title: 'Particle Concentration',
    formula: 'Concentration = Particle Count / Sample Volume',
    description: 'Particle concentration per unit volume.',
  },
  {
    title: 'Cleanroom Classification',
    formula: 'ISO Class based on particles ≥ 0.5 μm per m³',
    description: 'ISO 14644-1 classification from measured concentration.',
  },
];

export default function CleanroomFormulasScreen() {
  return (
    <CalcScreen title="Cleanroom Formulas" subtitle="Key formulas for cleanroom testing">
      <Text style={styles.sectionLabel}>Reference</Text>
      {FORMULAS.map((f) => (
        <View key={f.title} style={styles.item}>
          <Text style={styles.itemTitle}>{f.title}</Text>
          <FormulaBlock accentColor={C.accent} title="Formula" description={f.description}>
            <Text style={formulaTextStyles.formulaText}>{f.formula}</Text>
          </FormulaBlock>
        </View>
      ))}
    </CalcScreen>
  );
}

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
  item: {
    marginBottom: SP.md,
  },
  itemTitle: {
    fontFamily: FONT.sansBold,
    fontSize: 16,
    color: C.ink,
    marginBottom: SP.sm,
  },
});
